import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import {openUrlInNewTab} from 'utils/files';
import {headOption} from 'utils/common';

import ExifImage from 'components/ExifImage';
import Loader from 'components/Loader';

import pdfIcon from './assets/pdf.svg';
import {PoidDocumentDropzone} from './components';

import './styles.css';

const MAX_DOCUMENTS_COUNT = 5;

const PoidDocumentContainer = ({children, onClick, active}) => (
  <div
    onClick={onClick}
    className={classNames(
      'documentContainer colab-centered colab-clickable colab-small-border-radius',
      {
        active
      }
    )}>
    <div className="previewContainer colab-centered">{children}</div>
  </div>
);

const PoidDocument = ({poid, handlePoidClick, active}) => {
  const isPdf = poid.extension === '.pdf';

  return (
    <PoidDocumentContainer
      onClick={() => handlePoidClick(poid)}
      active={active}>
      {!poid && <Loader />}
      {poid && isPdf && <img src={pdfIcon} alt="PDF Icon" />}
      {poid && !isPdf && <ExifImage src={poid.fileUrl} alt={poid.filename} />}
    </PoidDocumentContainer>
  );
};

class PoidCard extends React.Component<any> {
  state = {previewedPoid: {fileUrl: '', filename: ''}};

  // Use `componentDidUpdate` instead of `componentDidMount` in order to handle file uploads.
  componentDidUpdate(prevProps, prevState) {
    if (
      (!_.get(prevState, 'previewedPoid.fileUrl') &&
        !_.isEmpty(this.props.tenant.poidDocuments)) ||
      prevProps.tenant.poidDocuments.length !==
        this.props.tenant.poidDocuments.length
    ) {
      this.setState({
        previewedPoid: headOption(this.props.tenant.poidDocuments)
      });
    }
  }

  changePreviewedPoid = poid => this.setState({previewedPoid: poid});

  openPoid = poid => {
    if (poid.extension == '.pdf') {
      return openUrlInNewTab(this.state.previewedPoid.fileUrl);
    }

    return this.props.openPreviewPoidDocumentModal({
      poid
    });
  };

  render() {
    const {
      tenant,
      locationRef,
      bookingId,
      fetchMemberCheckInInfoExtraActions
    } = this.props;

    const hasUploadedDocuments = !_.isEmpty(tenant.poidDocuments);

    const hasPoidFileToPreview = _.get(this.state, 'previewedPoid.fileUrl');

    return (
      <div className="PoidCard">
        {!hasUploadedDocuments && (
          <PoidDocumentDropzone
            className="documentContainer colab-small-border-radius"
            tenantId={tenant.id}
            locationRef={locationRef}
            bookingId={bookingId}
            kycId={tenant.kyc}
            fetchMemberCheckInInfoExtraActions={
              fetchMemberCheckInInfoExtraActions
            }
          />
        )}

        {hasUploadedDocuments &&
          hasPoidFileToPreview && (
            <PoidDocument
              poid={this.state.previewedPoid}
              handlePoidClick={this.openPoid}
              active={false}
            />
          )}

        {hasUploadedDocuments && (
          <div className="documentsRow">
            {tenant.poidDocuments.map(poid => (
              <PoidDocument
                key={poid.fileUrl}
                poid={poid}
                handlePoidClick={this.changePreviewedPoid}
                active={poid.fileUrl === this.state.previewedPoid.fileUrl}
              />
            ))}

            {tenant.poidDocuments.length < MAX_DOCUMENTS_COUNT && (
              <PoidDocumentDropzone
                key={tenant.poidDocuments.length}
                className="documentContainer colab-small-border-radius colab-centered"
                tenantId={tenant.id}
                locationRef={locationRef}
                bookingId={bookingId}
                kycId={tenant.kyc}
                fetchMemberCheckInInfoExtraActions={
                  fetchMemberCheckInInfoExtraActions
                }
              />
            )}
          </div>
        )}

        <div className="text">
          <div className="photoId">Photo ID</div>
          <div className="tenantName">{tenant.fullName}</div>
        </div>
      </div>
    );
  }
}

export default PoidCard;
